import { CommonModule }                   from '@angular/common';
import { NgModule }                       from '@angular/core';
import { ErrorModule }                    from '@shared/form-elements/error/error.module';
import { DateRangePickerFilterComponent } from '@shared/list-operations/components/datepicker-filters/date-range-picker-filter/date-range-picker-filter.component';
import { DatepickerFilterModule }         from '@shared/list-operations/components/datepicker-filters/datepicker-filter/datepicker-filter.module';

@NgModule( {
	declarations: [
		DateRangePickerFilterComponent
	],
	imports: [
		CommonModule,
		ErrorModule,
		DatepickerFilterModule
	],
	exports: [
		DateRangePickerFilterComponent
	]
} )
export class DateRangePickerFilterModule {
}
